import { createElement } from 'react'
import { Navigate } from 'react-router-dom'

/**
 * Component factory for index routes that only redirect. Used instead of a
 * `loader` redirect so every leaf route has a component, which is what React
 * Router expects; `createElement` keeps routeConfig free of JSX.
 */
export const navigateTo = (to) => {
  const RedirectRoute = () => createElement(Navigate, { to, replace: true })
  RedirectRoute.displayName = `RedirectTo(${to})`
  return RedirectRoute
}
